import React from "react";
import PropTypes from "prop-types";

import { ConditionsGroupView } from "..";

function NextWorkflowConditionsGroupView({
  nextWorkflowGroup,
  children,
  ...props
}) {
  if (!nextWorkflowGroup?.conditions?.length)
    return <React.Fragment>{children([nextWorkflowGroup])}</React.Fragment>;

  return (
    <ConditionsGroupView
      conditionsGroupId={nextWorkflowGroup?.id}
      conditions={nextWorkflowGroup?.conditions}
      items={nextWorkflowGroup?.nextWorkflow}
      itemType="nextWorkflow"
      {...props}
    >
      {(args) => {
        return children(args);
      }}
    </ConditionsGroupView>
  );
}

NextWorkflowConditionsGroupView.propTypes = {
  nextWorkflowGroup: PropTypes.oneOfType([
    PropTypes.shape({
      conditions: PropTypes.array,
      nextWorkflow: PropTypes.array,
    }),
    PropTypes.object,
  ]),
  children: PropTypes.func,
};

NextWorkflowConditionsGroupView.defaultProps = {
  children: () => {},
  nextWorkflowGroup: null,
};

export default NextWorkflowConditionsGroupView;
